@if (
  {
    data: templateData$ | async,
    loading: loadingService.loading$ | async,
    templateTitle: templateTitle$ | async,
  };
  as tab
) {
  <h1 class="page-title">{{ tab.templateTitle }}</h1>
  <div class="title-underline"></div>
  <ng-container [ngTemplateOutlet]="template"></ng-container>
  <app-template-button-row [tab]="tab"></app-template-button-row>
}
